export default "__VITE_ASSET__ChnuWlvY__"